import React, { useEffect, useState, useRef } from 'react';

const StatusPanel = ({ status, tripDetails }) => {
    const safeStatus = status || {};

    return (
        <div className="status-panel" style={{
            padding: '5px',
            background: '#ffffffcf',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            borderRadius: "0px 0px 39px 39px"
          }}>
            <div style={{display: "inline-flex", width: "100%", justifyContent: "space-between", fontSize: "smaller", paddingRight: "10px", paddingLeft: "10px"}}>
                <label style={{marginBottom: "0px"}}><strong>Trip Info:</strong> {tripDetails || 'No trip selected'}</label>
                <label style={{marginBottom: "0px"}}><strong>Vehicle:</strong> {safeStatus.vehicle || "None"}</label>
                <label style={{marginBottom: "0px"}}><strong>Route:</strong> {safeStatus.route || "None"}</label>
                <label style={{marginBottom: "0px"}}><strong>Status:</strong> {safeStatus.status || "Idle"}</label>
            </div>
        </div>
    );
};

export default StatusPanel;
